export default __webpack_public_path__ + "static/media/logo-white.358c5a70.png";